import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function CommissionPromoBand({
  canvasHomepage = false,
}: {
  canvasHomepage?: boolean;
}) {
  const { t } = useTranslation();

  const highlights = canvasHomepage
    ? (["canvas", "spaces", "largeScale", "interiors"] as const)
    : (["canvas", "brand", "spaces", "album", "prints"] as const);

  return (
    <section className="border-y border-accent/20 bg-gradient-to-r from-canvas-900 via-canvas-950 to-canvas-900">
      <div className="section-container flex flex-col gap-6 py-10 sm:flex-row sm:items-center sm:justify-between sm:py-12">
        <div className="max-w-xl">
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-accent">
            {t("home.commissionPromo.eyebrow")}
          </p>
          <h2 className="mt-2 font-display text-2xl font-semibold text-white sm:text-3xl">
            {canvasHomepage
              ? t("home.commissionPromo.canvasTitle")
              : t("home.commissionPromo.title")}
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-canvas-300">
            {canvasHomepage
              ? t("home.commissionPromo.canvasSubtitle")
              : t("home.commissionPromo.subtitle")}
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {highlights.map((key) => (
              <span
                key={key}
                className="rounded-full bg-white/5 px-3 py-1 text-xs font-medium text-canvas-200 ring-1 ring-white/10"
              >
                {t(`home.commissionPromo.highlights.${key}`)}
              </span>
            ))}
          </div>
        </div>
        <div className="flex shrink-0 flex-col gap-3 sm:items-end">
          <Link to="/contact#commission" className="btn-accent text-center">
            {t("home.commissionPromo.cta")}
          </Link>
          <p className="text-center text-xs text-canvas-500 sm:text-end">
            {t("home.commissionPromo.trust")}
          </p>
        </div>
      </div>
    </section>
  );
}
